import Label from 'bee-label'

export default Label
